import React from 'react';
import { Input, InputProps } from 'antd-v5';
import clas from 'classnames';

interface Props extends InputProps {
    className?: string;
}

const RecallInput: React.FC<Props> = ({ className, placeholder = '', ...props }) => {
    return <Input className={clas(className, 'recall-input')} placeholder={placeholder} {...props} />;
};
export default RecallInput;
